export const Types = {
  SET_FILTER: 'filterSearch/SET_FILTER',
  CLEAR_FILTER: 'filterSearch/CLEAR_FILTER',
};

export interface IRangeValues {
  min: number;
  max: number;
}

export interface IRules {
  pets: boolean;
  smoke: boolean;
  party: boolean;
}

export interface IAccommodations {
  apartment: boolean;
  inns: boolean;
  privateHomes: boolean;
  hotels: boolean;
  sharedRoom: boolean;
  cottage: boolean;
}

export interface IInstalations {
  pool: boolean;
  park: boolean;
  gym: boolean;
  wheelchairAccess: boolean;
}

export interface IAmenities {
  roomService: boolean;
  freeWifi: boolean;
  airConditioner: boolean;
  reception24h: boolean;
}

export interface ICenterDistance {
  oneKilometer: boolean;
  threeKilometers: boolean;
  fiveKilometers: boolean;
}

export interface ICategoryStarts {
  one: boolean;
  two: boolean;
  three: boolean;
  four: boolean;
  five: boolean;
}

export interface IBedPreference {
  singleBed: boolean;
  marriedBed: boolean;
}
export interface IFilterSearch {
  filtersCount: number;
  orderby: 'recommended' | 'lowestPrice' | 'highestPrice' | 'rating';
  breakfast: boolean;
  allowAnimals: boolean;
  freeCancellation: boolean;
  rangePrice: IRangeValues;
  rangeMiles: IRangeValues;
  rules: IRules;
  accommodations: IAccommodations;
  instalations: IInstalations;
  amenities: IAmenities;
  categoryStars: ICategoryStarts;
  centerDistance: ICenterDistance;
  bedPreference: IBedPreference;
}

export const initialState: IFilterSearch = {
  filtersCount: 0,
  orderby: 'recommended',
  breakfast: false,
  allowAnimals: false,
  freeCancellation: false,
  rangePrice: { min: 50, max: 6000 },
  rangeMiles: { min: 2000, max: 200000 },
  rules: {
    party: false,
    pets: false,
    smoke: false,
  },
  accommodations: {
    apartment: false,
    cottage: false,
    hotels: false,
    inns: false,
    privateHomes: false,
    sharedRoom: false,
  },
  instalations: {
    gym: false,
    park: false,
    pool: false,
    wheelchairAccess: false,
  },
  amenities: {
    airConditioner: false,
    freeWifi: false,
    reception24h: false,
    roomService: false,
  },
  categoryStars: {
    one: false,
    two: false,
    three: false,
    four: false,
    five: false,
  },
  centerDistance: {
    oneKilometer: false,
    threeKilometers: false,
    fiveKilometers: false,
  },
  bedPreference: {
    marriedBed: false,
    singleBed: false,
  },
};

export default function reducer(state = initialState, action: any = {}): IFilterSearch {
  switch (action.type) {
    case Types.SET_FILTER:
      return { ...state, ...action.payload };
    case Types.CLEAR_FILTER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export const clearFilter = () => ({
  type: Types.CLEAR_FILTER,
  payload: initialState,
});

export const setFilters = (filters: IFilterSearch) => ({
  type: Types.SET_FILTER,
  payload: filters,
});

export const filterSearchActions = { setFilters, clearFilter };
